import { GetJobAssets } from "screens/Assessments/logic/GetJobAsset";
import { GetJobLabors } from "screens/Assessments/logic/GetJobLabor";
import { GetJobMaterials } from "screens/Assessments/logic/GetJobMaterial";
import { GetJobMiscCosts } from "screens/Assessments/logic/GetJobMiscCost";
import { GetJobSubcontractor, SaveJobSubcontractor } from "screens/Assessments/logic/JobSubcontractor";
import { SaveJobAsset } from "screens/Assessments/logic/SaveJobAsset";
import { SaveJobLabor } from "screens/Assessments/logic/SaveJobLabor";
import { SaveJobMaterial } from "screens/Assessments/logic/SaveJobMaterial";
import { SaveJobMiscCost } from "screens/Assessments/logic/SaveJobMiscCost";

// Helper to copy all budgeted resources from workReq to new job
export const copyBudgetedResourcesToJobs = async (workReqID, jobs, navigate) => {
  // Fetch all resource templates from the WR (occurrenceNo === 0)
  const materialsRes = await GetJobMaterials(workReqID, 0, 0, navigate);
  const laborsRes = await GetJobLabors(workReqID, 0, 0, navigate);
  const subcontractorsRes = await GetJobSubcontractor(workReqID, 0, 0, navigate);
  const assetsRes = await GetJobAssets(workReqID, 0, 0, navigate);
  const miscsRes = await GetJobMiscCosts(workReqID, 0, 0, navigate);

  // Use empty array if error or result not found
  const materials = materialsRes ? materialsRes : [];
  const labors = laborsRes ? laborsRes : [];
  const subcontractors = subcontractorsRes ? subcontractorsRes : [];
  const assets = assetsRes ? assetsRes : [];
  const miscs = miscsRes ? miscsRes : [];

  // For each job (skip occurrenceNo: 0!), copy resources
  const jobsToCopy = jobs.filter(j => j.occurrenceNo !== 0);
  for (let job of jobsToCopy) {
    // Materials
    for (let m of materials) {
      const a = await SaveJobMaterial({
        ...m,
        jobMaterialID: 0,
        jobID: job.jobID,
        actualQuantity: 0,
        actualCostPerUnit: 0,
        actualPricePerUnit: 0,
        providedBy: m.providedBy || 0,
        sortOrder: m.sortOrder || 0,
        notes: m.notes || ""
      }, navigate);
      console.log(a)
    }
    // Labors
    for (let l of labors) {
      await SaveJobLabor({
        ...l,
        jobLaborID: 0,
        jobID: job.jobID,
        actualCostPerHour: 0,
        actualHours: 0,
        sortOrder: l.sortOrder || 0,
        notes: l.notes || ""
      }, navigate);
    }
    for (let s of subcontractors) {
      await SaveJobSubcontractor({
        ...s,
        jobSubcontractorID: 0,
        jobID: job.jobID,
        actualQuantityPerUnit: 0,
        actualCostPerUnit: 0,
        actualPricePerUnit: 0,
        sortOrder: s.sortOrder || 0,
        notes: s.notes || ""
      }, navigate);
    }
    // Assets
    for (let a of assets) {
      await SaveJobAsset({
        ...a,
        jobAssetID: 0,
        jobID: job.jobID,
        actualQuantity: 0,
        actualCostPerUnit: 0,
        actualDuration: 0,
        actualPricePerUnit: 0,
        sortOrder: a.sortOrder || 0,
        notes: a.notes || ""
      }, navigate);
    }
    // Misc Costs
    for (let mc of miscs) {
      await SaveJobMiscCost({
        ...mc,
        miscCostID: 0,
        jobID: job.jobID,
        actualCostAmount: 0,
        actualCustomerPrice: 0,
        sortOrder: mc.sortOrder || 0,
        notes: mc.notes || ""
      }, navigate);
    }
  }
};

export const copyBudgetedToActualsForJob = async ({
  jobAssetList,
  jobLaborList,
  jobSubcontractorList,
  jobMaterialList,
  jobMiscCostList,
  setLoading,
  toast,
  navigate
}) => {
  setLoading(true);
  try {
    // 1. Assets
    for (const asset of jobAssetList) {
      await SaveJobAsset({
        ...asset,
        // Only update actuals
        actualQuantity: asset.budgetedQuantity,
        actualCostPerUnit: asset.budgetedCostPerUnit,
        actualDuration: asset.budgetedDuration,
        actualPricePerUnit: asset.budgetedPricePerUnit,
      }, navigate);
    }
    // 2. Labors
    for (const labor of jobLaborList) {
      await SaveJobLabor({
        ...labor,
        actualCostPerHour: labor.budgetedCostPerHour,
        actualHours: labor.budgetedHours,
      }, navigate);
    }
    for (const subcontractor of jobSubcontractorList) {
      await SaveJobSubcontractor({
        ...subcontractor,
        actualUnitQuantity: subcontractor.budgetedUnitQuantity,
        actualCostPerUnit: subcontractor.budgetedCostPerUnit,
        actualPricePerUnit: subcontractor.budgetedPricePerUnit,
        actualMarkup: subcontractor.budgetedMarkup,
      }, navigate);
    }
    // 3. Materials
    for (const material of jobMaterialList) {
      const res = await SaveJobMaterial({
        ...material,
        actualQuantity: material.budgetedQuantity,
        actualCostPerUnit: material.budgetedCostPerUnit,
        actualPricePerUnit: material.budgetedPricePerUnit,
      }, navigate);
      console.log(res)
    }
    // 4. Misc Costs
    for (const miscCost of jobMiscCostList) {
      await SaveJobMiscCost({
        ...miscCost,
        actualCostAmount: miscCost.budgetedCostAmount,
        actualCustomerPrice: miscCost.budgetedCustomerPrice,
      }, navigate);
    }

    // toast.success("Budgeted values copied to Actuals!", {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: false,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    //   theme: "light"
    // });
  } catch (err) {
    toast.error("Failed to copy budgeted values to actuals.", {
      position: "top-right",
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
    console.error(err);
  } finally {
    setLoading(false);
  }
};
